Events = {

	url: "https://sommerfrische-ferien.firebaseio.com/places.json", // 
	defaultGroup: 'Region', 



	events: [], // data from json
	eventList: [], // grouped data to display with headlines
	markers: [], // map

	map: null,

	init: function() {
		this.loadJson();
	},

	loadJson: function() {
		$.getJSON(this.url, function(data) {
            Events.events = data; 
            //console.log(Events.events);
            Events.enrichEvents();
        });
	},

	// add helper fields and sort by timestamp 
	enrichEvents: function() {
		var id = 0;

		// scale for image resolution
		var scale = 1920;
        var isRetina = window.devicePixelRatio > 1;
        var winWidth = isRetina ? window.innerWidth*2 : window.innerWidth;
        $([480,736,980,1280,1920]).each(function(i,w) {
            //console.log('test', w, window.innerWidth);
            if (w >= winWidth/3) {
                scale = w;
                return false;
            }
        });

		this.events.forEach( function(e) { 
			e.Bilder.split("\n").forEach( function(image,index){
				//console.log("-",image,index);
            	// image with resolution
				if (image.length > 3) e["Bild"+Events.nf(index+1)] = scale + "/" + image;
			});

			e.id = id;
	        id++;
        });


		this.sortEventsListBy(this.defaultGroup);


		setTimeout(function(){
			Events.initMap();
		}, 800);
		
	},


	sortEventsListBy: function(attr) {
		var tmpEvents = this.events.slice();

        this.eventList = this.groupBy(tmpEvents, function(item) {
			return [item[attr] ]; 
		});

        this.displayEventsList();
        
	},

	displayEventsList: function() {
		var tplId = '#tpl';
		var anchor = '#places';

		var template = $(tplId).html();
        var stone = Handlebars.compile(template)({group: this.eventList});
        
        $(anchor).fadeOut(function(){
            //console.log(anchor)
            $(anchor).empty();
            $(anchor).append(stone);
            $(anchor).fadeIn();

            // $('.accordion').accordion({

            // });
            $('#dates a').scrolly();


	        $("#dates").on('click', '.showOnMap', function(event) {
	        	var id = $(this).data('id');
	        	Events.openMarker(id);
	        });


        });

        
	}, 


	initMap: function() {
        this.map = L.map('map').setView([50.63, 11.19], 12);
        var isRetina = window.devicePixelRatio > 1;

		L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}' + (isRetina ? '@2x':'') + '.png?access_token={accessToken}', {
		    attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
		    maxZoom: 18,
		    id: 'mapbox.streets',
		    accessToken: 'pk.eyJ1Ijoic2YyMDE3IiwiYSI6ImNqNHNieTJ6YjB0dnQzM3FocWgwbGh4d3YifQ.2dlpyHHL9sCBw0iq9B0EPA',
		    // scrollWheelZoom: false,
		    // touchZoom: false,

		}).addTo(this.map);

		// configure map
		this.map.scrollWheelZoom.disable();

		// autolocate
		// this.map.locate({setView: true, maxZoom: 14});
		// this.map.on('locationfound', this.onLocationFound);
		// this.map.on('locationerror', this.onLocationError);

		this.standardIcon = L.icon({
			iconUrl: 'images/map-marker_02.svg', // 01
			iconSize: [40, 40],
			iconAnchor: [20, 40],
			// popupAnchor: [-3, -76],
			// shadowUrl: 'my-icon-shadow.png',
			// shadowSize: [68, 95],
			// shadowAnchor: [22, 94]
		});

		this.collectionIcon = L.icon({
			iconUrl: 'images/map-marker_02.svg',
			iconSize: [40, 40],
			iconAnchor: [20, 40],
			// popupAnchor: [-3, -76],
			// shadowUrl: 'my-icon-shadow.png',
			// shadowSize: [68, 95],
			// shadowAnchor: [22, 94]
		});

		// show markers
        this.initMarkers();
        
    },

   	onLocationFound: function(e) {
   		console.log(e);
	    var radius = e.accuracy / 2;
	    L.circle(e.latlng, radius).addTo(Events.map);
	},

	onLocationError: function(e) {
	    
   		console.log("error", e);
	},

    initMarkers: function(){

    	var template = $("#infowinTpl").html();
        
    	var group = new L.featureGroup();

    	this.events.forEach( function(e) { 
            
    		if (e.lat && e.lng) {

    			var content = Handlebars.compile(template)({event: e});

		        var marker = L.marker([e.lat, e.lng], {
		        	title: e.Titel,
		        	icon: Events.standardIcon,

		        }).addTo(group); // Events.map
		        marker.bindPopup(content, {
		        	maxWidth: Math.min(400, window.innerWidth * .5),
		        	maxHeight: 400
		        });
		        Events.markers[e.id] = marker;

    		}

        });
    	group.addTo(Events.map);

    	// mask
		var bounds = group.getBounds().pad(0.14); // extend by 10%
		L.mask(bounds).addTo(this.map); 

		// center
		this.map.setView( bounds.getCenter() );
    },

    // from list
    openMarker: function(id){
    	Events.markers[id].openPopup();
    },




	// helper

	groupBy: function( array , f ) {
	  var groups = [];
	  array.forEach( function( o )
	  {
	    var group = JSON.stringify( f(o) );
	    groups[group] = groups[group] || {headline: f(o)[0], events: []};
	    groups[group].events.push( o );  
	  });

	  return Object.keys(groups).map( function( group )
	  {
	    return groups[group]; 
	  })
	  return [];
	},


	nf: function (n){
	    return n > 9 ? "" + n: "0" + n;
	}


};

